module.exports = __webpack_public_path__ + "assets/img/ZTS-FR20-M.54c733d9.png";